"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth0PermissionValue = exports.Auth0PermissionType = exports.Auth0Scope = exports.Auth0Access = exports.AuthScope = void 0;
// TO DELETE WHEN MIGRATION Auth0
var AuthScope;
(function (AuthScope) {
    AuthScope["CUSTOMER"] = "customer";
    AuthScope["EXTERNAL"] = "external";
    AuthScope["TRADER"] = "trader";
    AuthScope["ADMIN"] = "admin";
    AuthScope["DISPATCHER"] = "dispatcher";
})(AuthScope = exports.AuthScope || (exports.AuthScope = {}));
var Auth0Access;
(function (Auth0Access) {
    Auth0Access["BACKOFFICE"] = "access:backoffice";
    Auth0Access["TRADER"] = "access:trader";
    Auth0Access["CALLCENTER"] = "access:callcenter";
    Auth0Access["FRONT"] = "access:front";
})(Auth0Access = exports.Auth0Access || (exports.Auth0Access = {}));
var Auth0Scope;
(function (Auth0Scope) {
    Auth0Scope["CUSTOMER"] = "scope:customer";
    Auth0Scope["TRADER"] = "scope:trader";
})(Auth0Scope = exports.Auth0Scope || (exports.Auth0Scope = {}));
var Auth0PermissionType;
(function (Auth0PermissionType) {
    Auth0PermissionType["READ"] = "read";
    Auth0PermissionType["WRITE"] = "write";
    Auth0PermissionType["ADMIN"] = "admin";
})(Auth0PermissionType = exports.Auth0PermissionType || (exports.Auth0PermissionType = {}));
var Auth0PermissionValue;
(function (Auth0PermissionValue) {
    Auth0PermissionValue["INTERVENTION"] = "intervention";
    Auth0PermissionValue["TASK"] = "task";
    Auth0PermissionValue["CLAIM"] = "claim";
    Auth0PermissionValue["MARKETPLACE"] = "marketplace";
    Auth0PermissionValue["TRADER"] = "trader";
    Auth0PermissionValue["CATALOG"] = "catalog";
    Auth0PermissionValue["CUSTOMER"] = "customer";
    Auth0PermissionValue["USER"] = "user";
    Auth0PermissionValue["VOUCHER"] = "voucher";
    Auth0PermissionValue["REVIEW"] = "review";
})(Auth0PermissionValue = exports.Auth0PermissionValue || (exports.Auth0PermissionValue = {}));
//# sourceMappingURL=auth.js.map